import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { format } from "date-fns";

import * as config from "@/config";

import { type DailyWordCountData, type DateRange } from "../types";
import { hermesFetch, HermesApiError } from "./hermes-fetch";
import { useHermesApiToken } from "./use-hermes-api-token";

/**
 * Hook to fetch the Activity Report Insights data from Hermes.
 */
export function useWordCountActivity(
  assessmentId: string,
  workId: string,
  studentIds: string[],
  dateRange?: DateRange
): UseQueryResult<DailyWordCountData> {
  const apiToken = useHermesApiToken({ assessmentId, workId });
  return useQuery(
    [`insights/word_counts`, studentIds, dateRange],
    async () => {
      let hermesUrl = `${config.HERMESV2_ENDPOINT}/api/insights/word_counts`;
      if (dateRange && dateRange[0] && dateRange[1]) {
        const startDate = format(dateRange[0], "yyyy-MM-dd");
        const endDate = format(dateRange[1], "yyyy-MM-dd");
        hermesUrl += `?start_date=${startDate}&end_date=${endDate}`;
      }

      return hermesFetch<DailyWordCountData>(hermesUrl, apiToken, {
        method: "POST",
        body: JSON.stringify({
          user_ids: studentIds,
          group_ids: [],
        }),
      });
    },
    {
      cacheTime: 100,
      refetchInterval: false,
      useErrorBoundary: (error) =>
        error instanceof HermesApiError && error.status === 401,
      enabled: !!apiToken,
    }
  );
}
